import {useCallback, useContext} from 'react';
import {useDeleteExpressOrderMutation} from 'modules/products/services';
import {useExpressOrderGtag} from 'hooks/analytics/gtag/catalog/useExpressOrderGtag';
import {FilterPickupTodayButtonContext} from 'plugins/modules/filter/context/FilterPickupTodayButtonContext';
import {FilterContext} from 'plugins/modules/filter/context/new';
import {useListingContext} from 'plugins/modules/listing/context';
import {IProductShort} from 'modules/products/types';
import {useGetAbExpressOrder} from 'modules/ab-tests/hooks';

export const useExpressOrderClear = () => {
    const {wineShop, setWineShop} = useContext(FilterPickupTodayButtonContext);
    const {refetch: refetchFilters} = useContext(FilterContext);
    const {handleSetPage} = useListingContext<IProductShort>();

    const {isActive} = useGetAbExpressOrder();
    const [deleteExpressOrder] = useDeleteExpressOrderMutation();
    const {sendSwitchOffEvent, sendDiscardEvent} = useExpressOrderGtag(wineShop);

    const handleClearExpressOrder = useCallback(async () => {
        try {
            const response = await deleteExpressOrder();

            if ('error' in response || !response.data?.ok) {
                return;
            }

            if (wineShop && isActive) {
                sendDiscardEvent(wineShop?.titleVinoteki);
            }
            sendSwitchOffEvent();
            setWineShop?.(undefined);
            refetchFilters?.();
            handleSetPage(1);
        } catch (e) {
            console.error(e);
        }
    }, [
        deleteExpressOrder,
        wineShop,
        isActive,
        sendDiscardEvent,
        sendSwitchOffEvent,
        setWineShop,
        refetchFilters,
        handleSetPage,
    ]);

    return {handleClearExpressOrder};
};
